(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[489,379],{

/***/ 7347:
/***/ (function(module) {

/* Font Face Observer v2.1.0 - © Bram Stein. License: BSD-3-Clause */(function(){function l(a,b){document.addEventListener?a.addEventListener("scroll",b,!1):a.attachEvent("scroll",b)}function m(a){document.body?a():document.addEventListener?document.addEventListener("DOMContentLoaded",function c(){document.removeEventListener("DOMContentLoaded",c);a()}):document.attachEvent("onreadystatechange",function k(){if("interactive"==document.readyState||"complete"==document.readyState)document.detachEvent("onreadystatechange",k),a()})};function t(a){this.a=document.createElement("div");this.a.setAttribute("aria-hidden","true");this.a.appendChild(document.createTextNode(a));this.b=document.createElement("span");this.c=document.createElement("span");this.h=document.createElement("span");this.f=document.createElement("span");this.g=-1;this.b.style.cssText="max-width:none;display:inline-block;position:absolute;height:100%;width:100%;overflow:scroll;font-size:16px;";this.c.style.cssText="max-width:none;display:inline-block;position:absolute;height:100%;width:100%;overflow:scroll;font-size:16px;";
this.f.style.cssText="max-width:none;display:inline-block;position:absolute;height:100%;width:100%;overflow:scroll;font-size:16px;";this.h.style.cssText="display:inline-block;width:200%;height:200%;font-size:16px;max-width:none;";this.b.appendChild(this.h);this.c.appendChild(this.f);this.a.appendChild(this.b);this.a.appendChild(this.c)}
function u(a,b){a.a.style.cssText="max-width:none;min-width:20px;min-height:20px;display:inline-block;overflow:hidden;position:absolute;width:auto;margin:0;padding:0;top:-999px;white-space:nowrap;font-synthesis:none;font:"+b+";"}function z(a){var b=a.a.offsetWidth,c=b+100;a.f.style.width=c+"px";a.c.scrollLeft=c;a.b.scrollLeft=a.b.scrollWidth+100;return a.g!==b?(a.g=b,!0):!1}function A(a,b){function c(){var a=k;z(a)&&a.a.parentNode&&b(a.g)}var k=a;l(a.b,c);l(a.c,c);z(a)};function B(a,b){var c=b||{};this.family=a;this.style=c.style||"normal";this.weight=c.weight||"normal";this.stretch=c.stretch||"normal"}var C=null,D=null,E=null,F=null;function G(){if(null===D)if(J()&&/Apple/.test(window.navigator.vendor)){var a=/AppleWebKit\/([0-9]+)(?:\.([0-9]+))(?:\.([0-9]+))/.exec(window.navigator.userAgent);D=!!a&&603>parseInt(a[1],10)}else D=!1;return D}function J(){null===F&&(F=!!document.fonts);return F}
function K(){if(null===E){var a=document.createElement("div");try{a.style.font="condensed 100px sans-serif"}catch(b){}E=""!==a.style.font}return E}function L(a,b){return[a.style,a.weight,K()?a.stretch:"","100px",b].join(" ")}
B.prototype.load=function(a,b){var c=this,k=a||"BESbswy",r=0,n=b||3E3,H=(new Date).getTime();return new Promise(function(a,b){if(J()&&!G()){var M=new Promise(function(a,b){function e(){(new Date).getTime()-H>=n?b(Error(""+n+"ms timeout exceeded")):document.fonts.load(L(c,'"'+c.family+'"'),k).then(function(c){1<=c.length?a():setTimeout(e,25)},b)}e()}),N=new Promise(function(a,c){r=setTimeout(function(){c(Error(""+n+"ms timeout exceeded"))},n)});Promise.race([N,M]).then(function(){clearTimeout(r);a(c)},
b)}else m(function(){function v(){var b;if(b=-1!=f&&-1!=g||-1!=f&&-1!=h||-1!=g&&-1!=h)(b=f!=g&&f!=h&&g!=h)||(null===C&&(b=/AppleWebKit\/([0-9]+)(?:\.([0-9]+))/.exec(window.navigator.userAgent),C=!!b&&(536>parseInt(b[1],10)||536===parseInt(b[1],10)&&11>=parseInt(b[2],10))),b=C&&(f==w&&g==w&&h==w||f==x&&g==x&&h==x||f==y&&g==y&&h==y)),b=!b;b&&(d.parentNode&&d.parentNode.removeChild(d),clearTimeout(r),a(c))}function I(){if((new Date).getTime()-H>=n)d.parentNode&&d.parentNode.removeChild(d),b(Error(""+
n+"ms timeout exceeded"));else{var a=document.hidden;if(!0===a||void 0===a)f=e.a.offsetWidth,g=p.a.offsetWidth,h=q.a.offsetWidth,v();r=setTimeout(I,50)}}var e=new t(k),p=new t(k),q=new t(k),f=-1,g=-1,h=-1,w=-1,x=-1,y=-1,d=document.createElement("div");d.dir="ltr";u(e,L(c,"sans-serif"));u(p,L(c,"serif"));u(q,L(c,"monospace"));d.appendChild(e.a);d.appendChild(p.a);d.appendChild(q.a);document.body.appendChild(d);w=e.a.offsetWidth;x=p.a.offsetWidth;y=q.a.offsetWidth;I();A(e,function(a){f=a;v()});u(e,
L(c,'"'+c.family+'",sans-serif'));A(p,function(a){g=a;v()});u(p,L(c,'"'+c.family+'",serif'));A(q,function(a){h=a;v()});u(q,L(c,'"'+c.family+'",monospace'))})})}; true?module.exports=B:(0);}());


/***/ }),

/***/ 5219:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ components_Button; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(9521);
;// CONCATENATED MODULE: ./src/themes/default/components/Loading/styles.ts

function _templateObject() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  &,\n  &:after {\n    border-radius: 50%;\n    width: 18px;\n    height: 18px;\n    background-color: transparent;\n  }\n  & {\n    font-size: 10px;\n    position: relative;\n    text-indent: -9999em;\n    border-top: 2px solid rgba(255, 255, 255, 0.2);\n    border-right: 2px solid rgba(255, 255, 255, 0.2);\n    border-bottom: 2px solid rgba(255, 255, 255, 0.2);\n    border-left: 2px solid #ffffff;\n    -webkit-transform: translateZ(0);\n    -ms-transform: translateZ(0);\n    transform: translateZ(0);\n    -webkit-animation: load8 1.1s infinite linear;\n    animation: load8 1.1s infinite linear;\n  }\n\n  @-webkit-keyframes load8 {\n    0% {\n      -webkit-transform: rotate(0deg);\n      transform: rotate(0deg);\n    }\n    100% {\n      -webkit-transform: rotate(360deg);\n      transform: rotate(360deg);\n    }\n  }\n  @keyframes load8 {\n    0% {\n      -webkit-transform: rotate(0deg);\n      transform: rotate(0deg);\n    }\n    100% {\n      -webkit-transform: rotate(360deg);\n      transform: rotate(360deg);\n    }\n  }\n"
    ]);
    _templateObject = function() {
        return data;
    };
    return data;
}

const Wrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-51956618-0"
})(_templateObject());

;// CONCATENATED MODULE: ./src/themes/default/components/Loading/index.tsx


const Loading = ()=>{
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Wrapper, {});
};

// EXTERNAL MODULE: ./node_modules/polished/dist/polished.esm.js + 9 modules
var polished_esm = __webpack_require__(6637);
;// CONCATENATED MODULE: ./src/themes/default/components/Button/styles.ts

function styles_templateObject() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n          background: #fff;\n          color: ",
        ";\n\n          &:not(:disabled):hover {\n            filter: brightness(0.93);\n          }\n        "
    ]);
    styles_templateObject = function() {
        return data;
    };
    return data;
}
function _templateObject1() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n                  color: ",
        ";\n                "
    ]);
    _templateObject1 = function() {
        return data;
    };
    return data;
}
function _templateObject2() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n                  background-color: ",
        ";\n                "
    ]);
    _templateObject2 = function() {
        return data;
    };
    return data;
}
function _templateObject3() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n          &:not(:disabled):hover {\n            ",
        "\n          }\n        "
    ]);
    _templateObject3 = function() {
        return data;
    };
    return data;
}
function _templateObject4() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  align-items: center;\n  justify-content: center;\n\n  cursor: pointer;\n  border: ",
        ";\n  border-radius: ",
        ";\n\n  font-weight: 500;\n\n  background-color: ",
        ";\n  color: ",
        ";\n\n  font-size: ",
        ";\n  padding: ",
        ";\n\n  line-height: ",
        ";\n\n  transition: color 0.3s, background-color 0.3s, filter ease-in 0.3s;\n  will-change: color, background-color;\n\n  width: ",
        ";\n\n  height: 36px;\n\n  ",
        "\n\n  &:disabled {\n    cursor: not-allowed;\n    opacity: 0.5;\n  }\n"
    ]);
    _templateObject4 = function() {
        return data;
    };
    return data;
}


const StyledButton = styled_components_browser_esm/* default.button.withConfig */.ZP.button.withConfig({
    componentId: "sc-cf07a0ae-0"
})(_templateObject4(), (p)=>"1px solid ".concat(p.transparent ? "transparent" : p.theme.colors[p.color]), (p)=>p.theme.borderRadius, (p)=>p.transparent ? "transparent" : p.theme.colors[p.color], (p)=>p.transparent ? p.theme.colors[p.color] : (0,polished_esm/* readableColor */.XV)((0,polished_esm/* darken */._j)(0.22, p.theme.colors[p.color]), p.theme.colors.textDark, p.theme.colors.textLight), (p)=>p.theme.font[p.font], (p)=>p.theme.button[p.size], (p)=>p.lineHeight && p.theme.spacing[p.lineHeight], (p)=>p.width ? "".concat(p.width * 100, "% !important") : "", (param)=>{
    let { theme , variant , color , transparent  } = param;
    return variant === "outlined" ? (0,styled_components_browser_esm/* css */.iv)(styles_templateObject(), theme.colors[color]) : (0,styled_components_browser_esm/* css */.iv)(_templateObject3(), transparent ? (0,styled_components_browser_esm/* css */.iv)(_templateObject1(), (0,polished_esm/* transparentize */.DZ)(0.15, theme.colors[color])) : (0,styled_components_browser_esm/* css */.iv)(_templateObject2(), (0,polished_esm/* transparentize */.DZ)(0.15, theme.colors[color])));
});

;// CONCATENATED MODULE: ./src/themes/default/components/Button/index.tsx



const Button = (param)=>{
    let { children , size ="medium" , color ="primary" , font ="medium" , lineHeight , type , width , transparent , onClick , isLoading , disabled , variant ="default"  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledButton, {
        disabled: isLoading || disabled,
        transparent: transparent,
        size: size,
        font: font,
        color: color,
        lineHeight: lineHeight,
        type: type,
        width: width,
        onClick: onClick,
        variant: variant,
        children: isLoading ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Loading, {}) : children
    });
};
/* harmony default export */ var components_Button = (Button);


/***/ }),

/***/ 8927:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "U": function() { return /* binding */ Collapse; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(9521);
;// CONCATENATED MODULE: ./src/themes/default/components/Collapse/styles.ts

function _templateObject() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  height: 0;\n  opacity: 0;\n  overflow: hidden;\n\n  transition: height 0.3s ease, opacity 0.3s ease-in;\n"
    ]);
    _templateObject = function() {
        return data;
    };
    return data;
}

const Container = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-21205f59-0"
})(_templateObject());

;// CONCATENATED MODULE: ./src/themes/default/components/Collapse/index.tsx



const Collapse = (param)=>{
    let { isOpen =false , children  } = param;
    const containerRef = (0,react.useRef)(null);
    const contentRef = (0,react.useRef)(null);
    (0,react.useEffect)(()=>{
        if (!containerRef.current || !contentRef.current) return;
        if (isOpen) {
            containerRef.current.style.height = "".concat(contentRef.current.clientHeight, "px");
            containerRef.current.style.opacity = "1";
        } else {
            containerRef.current.style.height = "0px";
            containerRef.current.style.opacity = "0";
        }
    }, [
        isOpen
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Container, {
        ref: containerRef,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            ref: contentRef,
            children: children
        })
    });
};


/***/ }),

/***/ 4800:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Form_Input; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./node_modules/react-icons/fi/index.esm.js
var index_esm = __webpack_require__(6893);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/polished/dist/polished.esm.js + 9 modules
var polished_esm = __webpack_require__(6637);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(9521);
;// CONCATENATED MODULE: ./src/themes/default/components/Form/Input/styles.ts

function _templateObject() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: relative;\n  width: 100%;\n  height: 36px;\n"
    ]);
    _templateObject = function() {
        return data;
    };
    return data;
}
function _templateObject1() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: absolute !important;\n  cursor: pointer;\n  font-size: ",
        ";\n  line-height: 1em;\n\n  top: 50%;\n  transform: translateY(-50%);\n\n  right: ",
        ";\n"
    ]);
    _templateObject1 = function() {
        return data;
    };
    return data;
}
function _templateObject2() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n  height: 100%;\n  padding: ",
        " 14px;\n  padding-right: ",
        ";\n  border-radius: ",
        ";\n  font-size: ",
        ";\n  line-height: ",
        ";\n  border: 1px solid ",
        ";\n  background-color: ",
        ";\n  color: ",
        ";\n\n  transition: background-color 0.3s, border 0.3s;\n  will-change: background-color, border;\n\n  &:disabled {\n    background-color: ",
        ";\n  }\n\n  &:focus {\n    border: 1px solid ",
        ";\n  }\n"
    ]);
    _templateObject2 = function() {
        return data;
    };
    return data;
}


const WrapperInput = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-2b931ea9-0"
})(_templateObject());
const WrapperIcon = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    componentId: "sc-2b931ea9-1"
})(_templateObject1(), (p)=>p.theme.font.small, (p)=>p.theme.spacing.medium);
const StyledInput = styled_components_browser_esm/* default.input.withConfig */.ZP.input.withConfig({
    componentId: "sc-2b931ea9-2"
})(_templateObject2(), (p)=>p.theme.spacing.small, (p)=>p.hasIcon ? p.theme.spacing.xxLarge : p.theme.spacing.medium, (p)=>p.theme.borderRadius, (p)=>p.theme.font.small, (p)=>p.theme.spacing.medium, (p)=>p.theme.colors.border, (p)=>p.theme.input[p.color], (p)=>(0,polished_esm/* readableColor */.XV)((0,polished_esm/* darken */._j)(0.2, p.theme.input[p.color]), p.theme.colors.textDark, p.theme.colors.textLight), (p)=>p.theme.input.disabled, (p)=>p.theme.colors.primary);

;// CONCATENATED MODULE: ./src/themes/default/components/Form/Input/index.tsx




const Input = (param)=>{
    let { placeholder , disabled =false , color ="primary" , name , autoFocus =false , onChange , onBlur , value , onFocus , type , maxLength , onKeyPress  } = param;
    const [_type, setType] = (0,react.useState)(type);
    const hasIcon = (0,react.useMemo)(()=>{
        return type === "password";
    }, [
        type
    ]);
    const handleTogglePassword = ()=>{
        setType((prev)=>prev === "password" ? "text" : "password");
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(WrapperInput, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledInput, {
                hasIcon: hasIcon,
                autoFocus: autoFocus,
                id: name,
                name: name,
                color: color,
                placeholder: placeholder,
                disabled: disabled,
                onChange: onChange,
                onBlur: onBlur,
                onFocus: onFocus,
                onKeyPress: onKeyPress,
                value: value,
                type: _type,
                maxLength: maxLength
            }),
            hasIcon && /*#__PURE__*/ (0,jsx_runtime.jsx)(WrapperIcon, {
                "data-title": _type === "password" ? "Mostrar senha" : "Esconder senha",
                onClick: handleTogglePassword,
                children: _type === "password" ? /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* FiLock */.UIZ, {}) : /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* FiUnlock */.PdD, {})
            })
        ]
    });
};
/* harmony default export */ var Form_Input = (Input);


/***/ }),

/***/ 1331:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "X8": function() { return /* binding */ BadgeCount; },
/* harmony export */   "aV": function() { return /* binding */ Overlay; },
/* harmony export */   "ck": function() { return /* binding */ Item; },
/* harmony export */   "im": function() { return /* binding */ Wrapper; },
/* harmony export */   "l_": function() { return /* binding */ MenuItemContent; },
/* harmony export */   "sN": function() { return /* binding */ MenuItem; },
/* harmony export */   "u": function() { return /* binding */ Tooltip; },
/* harmony export */   "vb": function() { return /* binding */ DropDown; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(9521);

function _templateObject() {
    const data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: flex;\n  z-index: 1;\n  gap: ",
        ";\n"
    ]);
    _templateObject = function() {
        return data;
    };
    return data;
}
function _templateObject1() {
    const data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  position: absolute;\n  z-index: 1;\n  bottom: -6px;\n  left: -6px;\n  background-color: ",
        ";\n  color: ",
        ";\n  font-size: 9px;\n  width: 15px;\n  height: 15px;\n  letter-spacing: 0;\n\n  display: flex;\n  align-items: center;\n  justify-content: center;\n\n  border: 1px solid white;\n  border-radius: 100%;\n\n  transition: transform 0.3s;\n  will-change: transform;\n\n  &:hover {\n    transform: scale(1.25);\n  }\n"
    ]);
    _templateObject1 = function() {
        return data;
    };
    return data;
}
function _templateObject2() {
    const data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  position: relative;\n\n  &.user {\n    z-index: 2;\n  }\n\n  @media (min-width: 768px) {\n    &.Search {\n      display: none;\n    }\n  }\n"
    ]);
    _templateObject2 = function() {
        return data;
    };
    return data;
}
function _templateObject3() {
    const data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  border: none;\n  background-color: transparent;\n  color: inherit;\n  font-size: ",
        ";\n\n  position: relative;\n\n  transition: opacity 0.3s;\n  will-change: opacity;\n\n  z-index: 1;\n\n  & svg {\n    transition: color 0.3s, fill 0.3s, opacity 0.3s;\n    will-change: color, fill, opacity;\n  }\n\n  &:not(.menu--open):hover {\n    opacity: 0.5;\n  }\n\n  &.menu--open {\n    & svg {\n      color: ",
        ";\n      fill: ",
        ";\n    }\n  }\n\n  &.menu--open ~ {\n    color: red;\n  }\n\n  @media (max-width: 768px) {\n    font-size: ",
        ";\n  }\n"
    ]);
    _templateObject3 = function() {
        return data;
    };
    return data;
}
function _templateObject4() {
    const data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        ""
    ]);
    _templateObject4 = function() {
        return data;
    };
    return data;
}
function _templateObject5() {
    const data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  position: absolute;\n  top: calc(100% + 15px);\n  right: -16px;\n  background-color: ",
        ";\n  z-index: 1;\n  min-width: 170px;\n\n  ::before {\n    content: '';\n    position: absolute;\n    bottom: 100%;\n    right: 16px;\n    background-color: transparent;\n    border-width: calc(",
        " / 2);\n    border-style: solid;\n    border-color: transparent transparent ",
        ";\n  }\n\n  opacity: 0;\n  visibility: hidden;\n\n  transition: opacity 0.3s, visibility 0.3s, transform 0.3s;\n  will-change: opacity, visibility, transform;\n  transform: scale(0.9);\n\n  &.isVisible {\n    opacity: 1;\n    visibility: visible;\n    transform: scale(1);\n  }\n"
    ]);
    _templateObject5 = function() {
        return data;
    };
    return data;
}
function _templateObject6() {
    const data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  text-decoration: none;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  white-space: nowrap;\n  padding: ",
        " ",
        ";\n  line-height: ",
        ";\n  gap: ",
        ";\n  font-size: ",
        ";\n  letter-spacing: 1px;\n  font-weight: 400;\n\n  color: inherit;\n\n  transition: background-color 0.3s;\n  will-change: background-color;\n\n  &:hover {\n    background-color: ",
        ";\n  }\n\n  & > svg {\n    font-size: ",
        ";\n    margin-right: ",
        ";\n  }\n"
    ]);
    _templateObject6 = function() {
        return data;
    };
    return data;
}
function _templateObject7() {
    const data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  background-color: #000;\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n\n  opacity: 0;\n  visibility: hidden;\n\n  transition: opacity 0.3s, visibility 0.3s;\n  will-change: opacity, visibility;\n\n  &.isVisible {\n    opacity: 0.45;\n    visibility: visible;\n  }\n"
    ]);
    _templateObject7 = function() {
        return data;
    };
    return data;
}

const Wrapper = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-d6b63751-0"
})(_templateObject(), (p)=>p.theme.spacing.medium);
const BadgeCount = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].span.withConfig */ .ZP.span.withConfig({
    componentId: "sc-d6b63751-1"
})(_templateObject1(), (p)=>p.theme.colors.primary, (p)=>p.theme.colors.textLight);
const MenuItem = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-d6b63751-2"
})(_templateObject2());
const MenuItemContent = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].button.withConfig */ .ZP.button.withConfig({
    componentId: "sc-d6b63751-3"
})(_templateObject3(), (p)=>p.theme.font.xLarge, (p)=>p.theme.colors.background, (p)=>p.theme.colors.background, (p)=>p.theme.font.large);
const Tooltip = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-d6b63751-4"
})(_templateObject4());
const DropDown = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-d6b63751-5"
})(_templateObject5(), (p)=>p.theme.colors.background, (p)=>p.theme.font.xLarge, (p)=>p.theme.colors.background);
const Item = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-d6b63751-6"
})(_templateObject6(), (p)=>p.theme.spacing.small, (p)=>p.theme.spacing.medium, (p)=>p.theme.spacing.large, (p)=>p.theme.spacing.small, (p)=>p.theme.font.small, (p)=>p.theme.colors.backgroundHover, (p)=>p.theme.font.medium, (p)=>p.theme.spacing.small);
const Overlay = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-d6b63751-7"
})(_templateObject7());


/***/ }),

/***/ 4617:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ components_Header; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./node_modules/react-icons/fi/index.esm.js
var index_esm = __webpack_require__(6893);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(1664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/react-icons/io5/index.esm.js
var io5_index_esm = __webpack_require__(155);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./src/themes/default/components/Header/components/Menu/styles.ts
var styles = __webpack_require__(1331);
;// CONCATENATED MODULE: ./src/themes/default/components/Header/components/Menu/index.tsx





const DropDownUser = dynamic_default()(()=>__webpack_require__.e(/* import() */ 979).then(__webpack_require__.bind(__webpack_require__, 6979)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(6979)
            ]
    },
    ssr: false
});
const Menu = (param)=>{
    let { isLogged , isUserMenuVisible , handleClickUser , handleClickFavorite , handleClickBag , handleClickSearch , authMenuLinks , logout , itemsQuantityBag  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(styles/* Wrapper */.im, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(styles/* MenuItem */.sN, {
                className: "Search",
                onClick: handleClickSearch,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(styles/* MenuItemContent */.l_, {
                    "data-title": "Pesquisar",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(io5_index_esm/* IoSearchOutline */.uFR, {})
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(styles/* MenuItem */.sN, {
                className: "user",
                onClick: handleClickUser,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(styles/* Tooltip */.u, {
                        className: isUserMenuVisible && isLogged ? "menu--open tooltip--off" : "",
                        "data-title": "Minha conta",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(styles/* MenuItemContent */.l_, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* FiUser */.fzv, {})
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(DropDownUser, {
                        isLogged: isLogged,
                        isUserMenuVisible: isUserMenuVisible,
                        authMenuLinks: authMenuLinks,
                        logout: logout
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(styles/* MenuItem */.sN, {
                onClick: handleClickFavorite,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(styles/* Tooltip */.u, {
                    "data-title": "Lista de desejos",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(styles/* MenuItemContent */.l_, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* FiHeart */.$aX, {})
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(styles/* MenuItem */.sN, {
                onClick: handleClickBag,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(styles/* Tooltip */.u, {
                    "data-title": "Sacola",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(styles/* MenuItemContent */.l_, {
                        suppressHydrationWarning: true,
                        children: [
                            (itemsQuantityBag || 0) > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(styles/* BadgeCount */.X8, {
                                children: itemsQuantityBag
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* FiShoppingBag */.x8h, {})
                        ]
                    })
                })
            })
        ]
    });
};
/* harmony default export */ var components_Menu = (Menu);

// EXTERNAL MODULE: ./src/themes/default/components/Collapse/index.tsx + 1 modules
var Collapse = __webpack_require__(8927);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(9521);
;// CONCATENATED MODULE: ./src/themes/default/components/Header/components/CategoriesMobile/styles.ts

function _templateObject() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: 0 0 0 ",
        ";\n  gap: 16px;\n\n  display: flex;\n  align-items: flex-start;\n\n  color: ",
        ";\n\n  flex-direction: column;\n\n  width: 100%;\n\n  overflow: hidden;\n\n  transition: all 0.3s;\n\n  padding: ",
        " 0 0 ",
        ";\n"
    ]);
    _templateObject = function() {
        return data;
    };
    return data;
}
function _templateObject1() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  max-height: 400px;\n  overflow: auto;\n\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  width: 100%;\n\n  padding: 0 ",
        " 0 0;\n"
    ]);
    _templateObject1 = function() {
        return data;
    };
    return data;
}
function _templateObject2() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  gap: ",
        ";\n  color: transparent;\n  width: 100%;\n\n  flex-direction: column;\n  align-items: flex-start;\n\n  &.isVisible {\n    color: inherit;\n  }\n"
    ]);
    _templateObject2 = function() {
        return data;
    };
    return data;
}
function _templateObject3() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  cursor: pointer;\n  padding: ",
        " 0;\n  line-height: ",
        ";\n\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  justify-content: space-between;\n\n  width: 100%;\n\n  &.Title {\n    color: ",
        ";\n    font-weight: 500;\n    margin-right: auto;\n  }\n\n  & > svg {\n    font-size: 12px;\n    line-height: 1em;\n    stroke-width: 3;\n    margin-bottom: 1px;\n    color: ",
        ";\n\n    transition: transform 0.3s;\n    will-change: transform;\n    transform: ",
        ";\n  }\n\n  & button {\n    text-transform: uppercase;\n    cursor: pointer;\n    font-size: ",
        ";\n    color: ",
        ";\n  }\n\n  & > div {\n    width: 100%;\n  }\n"
    ]);
    _templateObject3 = function() {
        return data;
    };
    return data;
}
function _templateObject4() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  text-transform: uppercase;\n  display: flex;\n  align-items: flex-start;\n  justify-content: flex-start;\n  font-size: ",
        ";\n  color: ",
        ";\n  z-index: 2;\n  padding: 10px;\n"
    ]);
    _templateObject4 = function() {
        return data;
    };
    return data;
}
function _templateObject5() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  align-items: center;\n  width: 100%;\n\n  & svg {\n    font-size: 11px;\n    line-height: 1em;\n    stroke-width: 3;\n    margin-bottom: 1px;\n    color: ",
        ";\n  }\n\n  & button {\n    text-transform: uppercase;\n    cursor: pointer;\n    font-size: ",
        ";\n    color: ",
        ";\n    display: flex;\n    align-items: center;\n    width: 100%;\n    justify-content: flex-start;\n    gap: ",
        ";\n  }\n"
    ]);
    _templateObject5 = function() {
        return data;
    };
    return data;
}

const SubCategories = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-f1f15d86-0"
})(_templateObject(), (p)=>p.theme.spacing.medium, (p)=>p.theme.colors.textSecondary, (p)=>p.theme.spacing.medium, (p)=>p.theme.spacing.medium);
const SubCategoriesList = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-f1f15d86-1"
})(_templateObject1(), (p)=>p.theme.spacing.xxxLarge);
const WrapperCategories = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-f1f15d86-2"
})(_templateObject2(), (p)=>p.theme.spacing.small);
const Category = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-f1f15d86-3"
})(_templateObject3(), (p)=>p.theme.spacing.small, (p)=>p.theme.spacing.medium, (p)=>p.theme.colors.primary, (p)=>p.theme.colors.textSecondary, (p)=>p.isOpen ? "rotate(180deg)" : "rotate(0deg)", (p)=>p.theme.font.xSmall, (p)=>p.theme.colors.textSecondary);
const Wrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-f1f15d86-4"
})(_templateObject4(), (p)=>p.theme.font.xSmall, (p)=>p.theme.colors.textSecondary);
const SubCategory = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-f1f15d86-5"
})(_templateObject5(), (p)=>p.theme.colors.textSecondary, (p)=>p.theme.font.xSmall, (p)=>p.theme.colors.textSecondary, (p)=>p.theme.spacing.small);

;// CONCATENATED MODULE: ./src/themes/default/components/Header/components/CategoriesMobile/index.tsx





const CategoriesMobile = (param)=>{
    let { categories , onClickCategory  } = param;
    const [subCategoriesVisible, setSubCategoriesVisible] = (0,react.useState)("");
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Wrapper, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(WrapperCategories, {
            children: (categories === null || categories === void 0 ? void 0 : categories.length) > 0 && categories.map((category)=>{
                var ref, ref1, ref2;
                /*#__PURE__*/ return (0,jsx_runtime.jsxs)(Category, {
                    isOpen: subCategoriesVisible === category._id,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                            type: "button",
                            onClick: ()=>onClickCategory(category),
                            children: [
                                category.name,
                                " "
                            ]
                        }),
                        !!(category === null || category === void 0 ? void 0 : (ref = category.subcategories) === null || ref === void 0 ? void 0 : ref.length) && /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* FiChevronUp */.rH8, {
                            onClick: ()=>setSubCategoriesVisible(subCategoriesVisible === category._id ? "" : category._id)
                        }),
                        !!((ref1 = category.subcategories) === null || ref1 === void 0 ? void 0 : ref1.length) && /*#__PURE__*/ (0,jsx_runtime.jsx)(Collapse/* Collapse */.U, {
                            isOpen: subCategoriesVisible === category._id,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SubCategories, {
                                children: category === null || category === void 0 ? void 0 : (ref2 = category.subcategories) === null || ref2 === void 0 ? void 0 : ref2.map((subcategory)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(SubCategory, {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                                            type: "button",
                                            onClick: ()=>onClickCategory(subcategory),
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* FiCornerDownRight */.w0f, {}),
                                                subcategory.name
                                            ]
                                        })
                                    }, subcategory._id))
                            })
                        })
                    ]
                }, category._id);
            })
        })
    });
};

// EXTERNAL MODULE: ./node_modules/fontfaceobserver/fontfaceobserver.standalone.js
var fontfaceobserver_standalone = __webpack_require__(7347);
var fontfaceobserver_standalone_default = /*#__PURE__*/__webpack_require__.n(fontfaceobserver_standalone);
;// CONCATENATED MODULE: ./node_modules/use-font-face-observer/dist/index.modern.js
function e(e=[],{testString:s,timeout:n}={},{showErrors:i}={showErrors:!1}){const[c,a]=(0,react.useState)(!1),f=JSON.stringify(e);return (0,react.useEffect)(()=>{const r=JSON.parse(f).map(({family:r,weight:t,style:e,stretch:i})=>new (fontfaceobserver_standalone_default())(r,{weight:t,style:e,stretch:i}).load(s,n));Promise.all(r).then(()=>a(!0)).catch(()=>{i&&console.error("An error occurred during font loading")})},[f,s,n,i]),c}/* harmony default export */ var index_modern = (e);
//# sourceMappingURL=index.modern.js.map

;// CONCATENATED MODULE: ./src/themes/default/components/Header/components/Categories/styles.ts

function styles_templateObject() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: ",
        ";\n  max-width: 100%;\n  padding: 0 ",
        ";\n\n  display: flex;\n  align-items: flex-start;\n\n  color: ",
        ";\n\n  flex-direction: column;\n"
    ]);
    styles_templateObject = function() {
        return data;
    };
    return data;
}
function styles_templateObject1() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: ",
        ";\n  max-width: 100%;\n  padding: 0 ",
        ";\n\n  display: flex;\n  align-items: stretch;\n\n  color: ",
        ";\n"
    ]);
    styles_templateObject1 = function() {
        return data;
    };
    return data;
}
function styles_templateObject2() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  gap: ",
        ";\n  padding: 0 ",
        " 0 ",
        ";\n\n  max-height: 75vh;\n  overflow-x: auto;\n  height: auto;\n\n  &:first-child {\n    padding-left: 0;\n  }\n\n  &:last-child {\n    border-right: none;\n  }\n"
    ]);
    styles_templateObject2 = function() {
        return data;
    };
    return data;
}
function styles_templateObject3() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  cursor: pointer;\n  color: ",
        ";\n  text-decoration: underline;\n  font-size: ",
        ";\n  text-transform: uppercase;\n"
    ]);
    styles_templateObject3 = function() {
        return data;
    };
    return data;
}
function styles_templateObject4() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  cursor: pointer;\n\n  & a:hover {\n    text-decoration: underline;\n  }\n\n  display: inline-flex;\n  align-items: center;\n  width: 100%;\n\n  gap: ",
        ";\n\n  & svg {\n    font-size: 15px;\n    line-height: 1em;\n    stroke-width: 2;\n    margin: 0;\n  }\n\n  & a {\n    text-transform: uppercase;\n    cursor: pointer;\n    font-size: ",
        ";\n    color: ",
        ";\n  }\n\n  & a.isActive {\n    text-decoration: underline;\n  }\n"
    ]);
    styles_templateObject4 = function() {
        return data;
    };
    return data;
}
function styles_templateObject5() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: ",
        ";\n  max-width: 100%;\n  padding: 0 ",
        ";\n\n  display: flex;\n  align-items: flex-start;\n\n  color: ",
        ";\n"
    ]);
    styles_templateObject5 = function() {
        return data;
    };
    return data;
}
function _templateObject6() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  max-height: 200px;\n  overflow: auto;\n\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n\n  padding: 0 ",
        " 0 0;\n"
    ]);
    _templateObject6 = function() {
        return data;
    };
    return data;
}
function _templateObject7() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n      flex: 1;\n      justify-content: space-between;\n    "
    ]);
    _templateObject7 = function() {
        return data;
    };
    return data;
}
function _templateObject8() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  gap: ",
        ";\n  color: transparent;\n\n  ",
        "\n\n  &.isVisible {\n    color: inherit;\n  }\n"
    ]);
    _templateObject8 = function() {
        return data;
    };
    return data;
}
function _templateObject9() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  cursor: default;\n  background: ",
        ";\n  border-bottom: 1px solid ",
        ";\n  position: absolute;\n  width: 100vw;\n  top: 100%;\n  left: 50%;\n  transform: translateX(-50%) translateY(-100%);\n  padding: ",
        " 0 ",
        ";\n\n  transition: transform 0.3s ease-in;\n  will-change: transform;\n\n  z-index: -1;\n\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: flex-start;\n\n  &.isHide {\n    transform: translateX(-50%) translateY(-100%) !important;\n    pointer-events: none;\n  }\n"
    ]);
    _templateObject9 = function() {
        return data;
    };
    return data;
}
function _templateObject10() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  white-space: nowrap;\n  cursor: pointer;\n  padding: ",
        " 0;\n  line-height: ",
        ";\n\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: ",
        ";\n\n  &:hover {\n    text-decoration: underline;\n\n    ",
        " {\n      transform: translateX(-50%) translateY(0%);\n    }\n  }\n\n  &.Title {\n    color: ",
        ";\n    font-weight: 500;\n  }\n\n  & svg {\n    font-size: 15px;\n    line-height: 1em;\n    stroke-width: 2;\n    margin-bottom: 1px;\n  }\n\n  & a {\n    text-transform: uppercase;\n    cursor: pointer;\n    font-size: ",
        ";\n    color: ",
        ";\n\n    display: flex;\n    align-items: center;\n\n    gap: ",
        ";\n\n    & svg {\n      margin-bottom: 0;\n    }\n  }\n"
    ]);
    _templateObject10 = function() {
        return data;
    };
    return data;
}
function _templateObject11() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  text-transform: uppercase;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: ",
        ";\n  color: ",
        ";\n  z-index: 2;\n  gap: ",
        ";\n"
    ]);
    _templateObject11 = function() {
        return data;
    };
    return data;
}
function _templateObject12() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: ",
        " 0;\n\n  & a:hover {\n    text-decoration: underline;\n  }\n\n  display: flex;\n  align-items: center;\n  width: 100%;\n\n  gap: ",
        ";\n\n  & svg {\n    font-size: 15px;\n    line-height: 1em;\n    stroke-width: 0;\n    margin: 0;\n  }\n\n  & a {\n    text-transform: uppercase;\n    cursor: pointer;\n    font-size: ",
        ";\n    color: ",
        ";\n  }\n"
    ]);
    _templateObject12 = function() {
        return data;
    };
    return data;
}
function _templateObject13() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  & svg {\n    font-size: 12px;\n    line-height: 1em;\n    stroke-width: 0;\n    margin-bottom: 1px;\n  }\n"
    ]);
    _templateObject13 = function() {
        return data;
    };
    return data;
}

const styles_SubCategories = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-18ade1d8-0"
})(styles_templateObject(), (p)=>p.theme.maxWidth, (p)=>p.theme.spacing.xLarge, (p)=>p.theme.colors.textSecondary);
const ContentDropdown = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-18ade1d8-1"
})(styles_templateObject1(), (p)=>p.theme.maxWidth, (p)=>p.theme.spacing.xLarge, (p)=>p.theme.colors.textSecondary);
const WrapperList = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-18ade1d8-2"
})(styles_templateObject2(), (p)=>p.theme.spacing.medium, (p)=>p.theme.spacing.xLarge, (p)=>p.theme.spacing.xLarge);
const ItemTitle = styled_components_browser_esm/* default.h2.withConfig */.ZP.h2.withConfig({
    componentId: "sc-18ade1d8-3"
})(styles_templateObject3(), (p)=>p.theme.colors.textPrimary, (p)=>p.theme.font.large);
const ItemList = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-18ade1d8-4"
})(styles_templateObject4(), (p)=>p.theme.spacing.small, (p)=>p.theme.font.xSmall, (p)=>p.theme.colors.textSecondary);
const AllCategories = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-18ade1d8-5"
})(styles_templateObject5(), (p)=>p.theme.maxWidth, (p)=>p.theme.spacing.xLarge, (p)=>p.theme.colors.textSecondary);
const styles_SubCategoriesList = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-18ade1d8-6"
})(_templateObject6(), (p)=>p.theme.spacing.giant);
const styles_WrapperCategories = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-18ade1d8-7"
})(_templateObject8(), (p)=>p.theme.spacing.xLarge, (p)=>p.fullWidth && (0,styled_components_browser_esm/* css */.iv)(_templateObject7()));
const WrapperDropdown = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-18ade1d8-8"
})(_templateObject9(), (p)=>p.theme.colors.background, (p)=>p.theme.colors.border, (p)=>p.theme.spacing.small, (p)=>p.theme.spacing.medium);
const styles_Category = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-18ade1d8-9"
})(_templateObject10(), (p)=>p.theme.spacing.small, (p)=>p.theme.spacing.medium, (p)=>p.theme.spacing.nano, WrapperDropdown, (p)=>p.theme.colors.primary, (p)=>p.theme.font.xSmall, (p)=>p.theme.colors.textSecondary, (p)=>p.theme.spacing.nano);
const styles_Wrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-18ade1d8-10"
})(_templateObject11(), (p)=>p.theme.font.xSmall, (p)=>p.theme.colors.textSecondary, (p)=>p.theme.spacing.xLarge);
const styles_SubCategory = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-18ade1d8-11"
})(_templateObject12(), (p)=>p.theme.spacing.small, (p)=>p.theme.spacing.small, (p)=>p.theme.font.xSmall, (p)=>p.theme.colors.textSecondary);
const WrapperRight = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-18ade1d8-12"
})(_templateObject13());

;// CONCATENATED MODULE: ./src/themes/default/components/Header/components/Categories/index.tsx
/* eslint-disable jsx-a11y/no-static-element-interactions */ /* eslint-disable jsx-a11y/click-events-have-key-events */ 





const Categories = (param)=>{
    let { categories  } = param;
    var ref, ref1, ref2;
    const isFontListLoaded = index_modern([
        {
            family: "Montserrat"
        }
    ]);
    const categoriesRef = (0,react.useRef)(null);
    const [categoriesFiltered, setCategoriesFiltered] = (0,react.useState)(categories);
    const [subCategoriesVisible, setSubCategoriesVisible] = (0,react.useState)("");
    const [categoriesVisible, setCategoriesVisibile] = (0,react.useState)(false);
    const [hideDropdown, setHideDropdown] = (0,react.useState)(false);
    (0,react.useEffect)(()=>{
        if (isFontListLoaded) {
            if (categoriesRef.current && categoriesRef.current.offsetWidth > 1040) {
                setCategoriesFiltered((prev)=>{
                    return prev === null || prev === void 0 ? void 0 : prev.slice(0, (prev === null || prev === void 0 ? void 0 : prev.length) - 1);
                });
            } else {
                setCategoriesVisibile(true);
            }
        }
    }, [
        categoriesFiltered,
        isFontListLoaded
    ]);
    const handleClickCategory = ()=>{
        setHideDropdown(true);
        setTimeout(()=>{
            setHideDropdown(false);
        }, 1000);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(styles_Wrapper, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(styles_WrapperCategories, {
            fullWidth: (categoriesFiltered === null || categoriesFiltered === void 0 ? void 0 : categoriesFiltered.length) !== (categories === null || categories === void 0 ? void 0 : categories.length),
            ref: categoriesRef,
            className: categoriesVisible ? "isVisible" : "",
            children: [
                (categoriesFiltered === null || categoriesFiltered === void 0 ? void 0 : categoriesFiltered.length) !== (categories === null || categories === void 0 ? void 0 : categories.length) && /*#__PURE__*/ (0,jsx_runtime.jsxs)(styles_Category, {
                    className: "Title",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* FiMenu */.cur, {}),
                        "Todas as Categorias",
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(WrapperDropdown, {
                            className: hideDropdown ? "isHide" : "",
                            onMouseLeave: ()=>setSubCategoriesVisible(""),
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(ContentDropdown, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(WrapperList, {
                                        bordered: !!subCategoriesVisible,
                                        children: categories === null || categories === void 0 ? void 0 : categories.map((category)=>{
                                            var ref;
                                            /*#__PURE__*/ return (0,jsx_runtime.jsxs)(ItemList, {
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                        href: "/categorias/".concat(category.tag),
                                                        onClick: handleClickCategory,
                                                        className: subCategoriesVisible === category._id ? "isActive" : "",
                                                        onMouseEnter: ()=>{
                                                            var ref;
                                                            if ((ref = category.subcategories) === null || ref === void 0 ? void 0 : ref.length) {
                                                                setSubCategoriesVisible(category === null || category === void 0 ? void 0 : category._id);
                                                            } else {
                                                                setSubCategoriesVisible("");
                                                            }
                                                        },
                                                        children: category.name
                                                    }),
                                                    !!(category === null || category === void 0 ? void 0 : (ref = category.subcategories) === null || ref === void 0 ? void 0 : ref.length) && /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* FiChevronRight */.Tfp, {})
                                                ]
                                            }, category._id);
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(WrapperList, {
                                        children: (ref = categories === null || categories === void 0 ? void 0 : categories.find((category)=>category._id === subCategoriesVisible)) === null || ref === void 0 ? void 0 : (ref1 = ref.subcategories) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.map) === null || ref2 === void 0 ? void 0 : ref2.call(ref1, (subcategory)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(ItemList, {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                    href: "/categorias/".concat(subcategory.tag),
                                                    onClick: handleClickCategory,
                                                    children: subcategory.name
                                                })
                                            }, subcategory._id))
                                    })
                                ]
                            })
                        })
                    ]
                }),
                categoriesFiltered === null || categoriesFiltered === void 0 ? void 0 : categoriesFiltered.map((category)=>{
                    var ref, ref1, ref2;
                    /*#__PURE__*/ return (0,jsx_runtime.jsxs)(styles_Category, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)((link_default()), {
                                href: "/categorias/".concat(category.tag),
                                onClick: handleClickCategory,
                                children: [
                                    category.name,
                                    !!((ref = category.subcategories) === null || ref === void 0 ? void 0 : ref.length) && /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* FiChevronDown */.bTu, {})
                                ]
                            }),
                            !!((ref1 = category.subcategories) === null || ref1 === void 0 ? void 0 : ref1.length) && /*#__PURE__*/ (0,jsx_runtime.jsx)(WrapperDropdown, {
                                className: hideDropdown ? "isHide" : "",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(styles_SubCategories, {
                                    children: category === null || category === void 0 ? void 0 : (ref2 = category.subcategories) === null || ref2 === void 0 ? void 0 : ref2.map((subcategory)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(styles_SubCategory, {
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                href: "/categorias/".concat(subcategory.tag),
                                                onClick: handleClickCategory,
                                                children: subcategory.name
                                            })
                                        }, subcategory._id))
                                })
                            })
                        ]
                    }, category._id);
                })
            ]
        })
    });
};

// EXTERNAL MODULE: ./src/themes/default/components/Button/index.tsx + 3 modules
var Button = __webpack_require__(5219);
// EXTERNAL MODULE: ./src/themes/default/components/Form/Input/index.tsx + 1 modules
var Input = __webpack_require__(4800);
;// CONCATENATED MODULE: ./src/themes/default/components/Header/components/SearchBar/styles.ts

function SearchBar_styles_templateObject() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  border-radius: ",
        ";\n  flex: 1;\n  display: flex;\n  max-width: 450px;\n\n  & input {\n    border-right: none !important;\n    border-top-right-radius: 0;\n    border-bottom-right-radius: 0;\n  }\n\n  & button {\n    border-top-left-radius: 0;\n    border-bottom-left-radius: 0;\n    width: 40px;\n  }\n"
    ]);
    SearchBar_styles_templateObject = function() {
        return data;
    };
    return data;
}

const SearchBar_styles_Wrapper = styled_components_browser_esm/* default.form.withConfig */.ZP.form.withConfig({
    componentId: "sc-96d122c5-0"
})(SearchBar_styles_templateObject(), (p)=>p.theme.borderRadius);

;// CONCATENATED MODULE: ./src/themes/default/components/Header/components/SearchBar/index.tsx






const SearchBar = (param)=>{
    let { placeholder , handleSearchClick  } = param;
    const [searchValue, setSearchValue] = (0,react.useState)("");
    function handleSetSearchValue(e) {
        setSearchValue(e.target.value);
    }
    function handleSubmit(e) {
        e.preventDefault();
        setSearchValue("");
        if (handleSearchClick) handleSearchClick(searchValue);
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(SearchBar_styles_Wrapper, {
        onSubmit: handleSubmit,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Input/* default */.Z, {
                name: "search",
                placeholder: placeholder,
                color: "secondary",
                value: searchValue,
                onChange: handleSetSearchValue
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Button["default"], {
                size: "xSmall",
                type: "submit",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(io5_index_esm/* IoSearchOutline */.uFR, {})
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/themes/default/components/Header/styles.ts

function Header_styles_templateObject() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: ",
        ";\n  border-bottom: 1px solid ",
        ";\n\n  flex-direction: column;\n\n  position: sticky;\n  left: 0;\n  right: 0;\n  top: 0;\n  z-index: 300;\n"
    ]);
    Header_styles_templateObject = function() {
        return data;
    };
    return data;
}
function Header_styles_templateObject1() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: relative;\n  overflow: unset;\n  background-color: ",
        ";\n  width: 100%;\n\n  display: flex;\n  flex-direction: column;\n  align-content: center;\n  align-items: center;\n  justify-content: center;\n"
    ]);
    Header_styles_templateObject1 = function() {
        return data;
    };
    return data;
}
function Header_styles_templateObject2() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  z-index: 2;\n  width: ",
        ";\n  max-width: 100%;\n  padding: ",
        ";\n  background-color: ",
        ";\n\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n\n  gap: ",
        ";\n\n  @media (max-width: 768px) {\n    padding: ",
        " ",
        ";\n\n    & > form {\n      display: none;\n    }\n  }\n"
    ]);
    Header_styles_templateObject2 = function() {
        return data;
    };
    return data;
}
function Header_styles_templateObject3() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-size: ",
        ";\n  display: flex;\n  align-items: center;\n  gap: ",
        ";\n  cursor: pointer;\n  max-height: 100%;\n\n  transition: opacity 0.4s;\n\n  &:hover {\n    opacity: 0.6;\n  }\n\n  & svg {\n    cursor: pointer;\n    stroke-width: 2;\n  }\n\n  & span {\n    font-weight: bold;\n    font-size: ",
        ";\n  }\n\n  > a {\n    height: 100%;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n  }\n\n  @media (min-width: 768px) {\n    & svg {\n      display: none;\n    }\n  }\n"
    ]);
    Header_styles_templateObject3 = function() {
        return data;
    };
    return data;
}
function Header_styles_templateObject4() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: ",
        ";\n  max-width: 100%;\n  padding: 0 ",
        ";\n\n  @media (max-width: 768px) {\n    display: none;\n  }\n"
    ]);
    Header_styles_templateObject4 = function() {
        return data;
    };
    return data;
}
function Header_styles_templateObject5() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  cursor: pointer;\n  width: 120px;\n  max-height: 80px;\n\n  object-position: left;\n  object-fit: contain;\n\n  transition: opacity 0.3s;\n  will-change: opacity;\n\n  &:hover {\n    opacity: 0.85;\n  }\n\n  @media (max-width: 768px) {\n    width: 90px;\n    max-height: 56px;\n  }\n"
    ]);
    Header_styles_templateObject5 = function() {
        return data;
    };
    return data;
}
function styles_templateObject6() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n  display: flex;\n  align-content: center;\n  justify-content: center;\n  border-bottom: 1px solid ",
        ";\n  background-color: ",
        ";\n\n  position: absolute;\n  top: 100%;\n\n  transition: transform 0.3s;\n\n  transform: translateY(-100%);\n\n  &.isVisible {\n    transform: translateY(0);\n  }\n\n  @media (min-width: 769px) {\n    display: none;\n  }\n\n  padding: 0 ",
        " ",
        ";\n\n  & > form {\n    max-width: 100%;\n  }\n"
    ]);
    styles_templateObject6 = function() {
        return data;
    };
    return data;
}
function styles_templateObject7() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: absolute;\n  background-color: black;\n\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n\n  z-index: 300;\n\n  visibility: hidden;\n  opacity: 0;\n\n  transition: visibility 0.3s, opacity 0.3s;\n\n  &.isOpen {\n    opacity: 0.25;\n    visibility: visible;\n  }\n"
    ]);
    styles_templateObject7 = function() {
        return data;
    };
    return data;
}
function styles_templateObject8() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: absolute;\n  background-color: white;\n\n  top: 0;\n  left: 0;\n  bottom: 0;\n  width: 300px;\n\n  z-index: 300;\n\n  border-right: 1px solid ",
        ";\n\n  visibility: hidden;\n  transform: translateX(-100%);\n\n  transition: transform 0.3s, visibility 0.3s;\n\n  &.isOpen {\n    transform: translateX(0);\n    visibility: visible;\n  }\n\n  > header {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    background-color: ",
        ";\n    padding: ",
        ";\n\n    border-bottom: 1px solid ",
        ";\n\n    position: sticky;\n    top: 0;\n\n    @media (max-width: 768px) {\n      font-size: ",
        ";\n\n      padding: ",
        ";\n    }\n\n    > h1 {\n      color: ",
        ";\n      font-size: ",
        ";\n      text-transform: uppercase;\n\n      @media (max-width: 768px) {\n        font-size: ",
        ";\n      }\n    }\n\n    > button {\n      cursor: pointer;\n      color: ",
        ";\n      background-color: transparent;\n      border: none;\n      display: flex;\n      align-items: center;\n      justify-content: center;\n      font-size: ",
        ";\n\n      & svg {\n        stroke-width: 3;\n      }\n    }\n  }\n"
    ]);
    styles_templateObject8 = function() {
        return data;
    };
    return data;
}

const Header_styles_Wrapper = styled_components_browser_esm/* default.header.withConfig */.ZP.header.withConfig({
    componentId: "sc-1d2abf95-0"
})(Header_styles_templateObject(), (p)=>p.theme.colors.primary, (p)=>p.theme.colors.border);
const Content = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-1d2abf95-1"
})(Header_styles_templateObject1(), (p)=>p.theme.header.background);
const TopBar = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-1d2abf95-2"
})(Header_styles_templateObject2(), (p)=>p.theme.maxWidth, (p)=>"12px ".concat(p.theme.spacing.xLarge), (p)=>p.theme.header.background, (p)=>p.theme.spacing.xLarge, (p)=>p.theme.spacing.medium, (p)=>p.theme.spacing.medium);
const WrapperLogo = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-1d2abf95-3"
})(Header_styles_templateObject3(), (p)=>p.theme.font.large, (p)=>p.theme.spacing.medium, (p)=>p.theme.font.xxLarge);
const NavBar = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-1d2abf95-4"
})(Header_styles_templateObject4(), (p)=>p.theme.maxWidth, (p)=>p.theme.spacing.xLarge);
const Logo = styled_components_browser_esm/* default.img.withConfig */.ZP.img.withConfig({
    componentId: "sc-1d2abf95-5"
})(Header_styles_templateObject5());
const WrapperSearchBar = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-1d2abf95-6"
})(styles_templateObject6(), (p)=>p.theme.colors.border, (p)=>p.theme.header.background, (p)=>p.theme.spacing.medium, (p)=>p.theme.spacing.medium);
const Overlay = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-1d2abf95-7"
})(styles_templateObject7());
const NavBarMobile = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-1d2abf95-8"
})(styles_templateObject8(), (p)=>p.theme.colors.border, (p)=>p.theme.colors.background, (p)=>"".concat(p.theme.spacing.large, " ").concat(p.theme.spacing.large, " ").concat(p.theme.spacing.medium), (p)=>p.theme.colors.border, (p)=>p.theme.font.large, (p)=>p.theme.spacing.medium, (p)=>p.theme.colors.textPrimary, (p)=>p.theme.font.xLarge, (p)=>p.theme.font.large, (p)=>p.theme.colors.textPrimary, (p)=>p.theme.font.xLarge);

;// CONCATENATED MODULE: ./src/themes/default/components/Header/index.tsx
/* eslint-disable jsx-a11y/anchor-is-valid */ 








// const Menu = dynamic(() => import('./components/Menu'), { ssr: false });
const Header = (param)=>{
    let { logo , isLogged , isUserMenuVisible , onClickUser , onClickFavorite , onClickBag , searchPlaceholder , onSearchClick , authMenuLinks , logout , categories , onClickCategory , itemsQuantityBag  } = param;
    const [searchIsOpen, setSearchIsOpen] = (0,react.useState)(false);
    const [menuIsOpen, setMenuIsOpen] = (0,react.useState)(false);
    const handleClickUser = ()=>{
        if (onClickUser) onClickUser();
    };
    const handleClickFavorite = ()=>{
        if (onClickFavorite) onClickFavorite();
    };
    const handleClickBag = ()=>{
        if (onClickBag) onClickBag();
    };
    const handleSearchClick = (searchValue)=>{
        if (onSearchClick) onSearchClick(searchValue);
        setSearchIsOpen(false);
    };
    const handleClickSearch = ()=>{
        setSearchIsOpen((prev)=>!prev);
    };
    const handleClickCategory = (category)=>{
        if (menuIsOpen) setMenuIsOpen(false);
        if (onClickCategory) onClickCategory(category);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Header_styles_Wrapper, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Content, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(TopBar, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(WrapperLogo, {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* FiMenu */.cur, {
                                            onClick: ()=>setMenuIsOpen((prev)=>!prev)
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                            href: "/",
                                            children: logo ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Logo, {
                                                src: logo
                                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                children: "LOGO"
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(SearchBar, {
                                    placeholder: searchPlaceholder,
                                    handleSearchClick: handleSearchClick
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(components_Menu, {
                                    logout: logout,
                                    isLogged: isLogged,
                                    isUserMenuVisible: isUserMenuVisible,
                                    handleClickSearch: handleClickSearch,
                                    handleClickUser: handleClickUser,
                                    handleClickFavorite: handleClickFavorite,
                                    handleClickBag: handleClickBag,
                                    authMenuLinks: authMenuLinks,
                                    itemsQuantityBag: itemsQuantityBag
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(WrapperSearchBar, {
                            "aria-hidden": !searchIsOpen,
                            className: searchIsOpen ? "isVisible" : "",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SearchBar, {
                                placeholder: searchPlaceholder,
                                handleSearchClick: handleSearchClick
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(NavBar, {
                            "aria-hidden": true,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Categories, {
                                categories: categories
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Overlay, {
                onClick: ()=>setMenuIsOpen(false),
                className: menuIsOpen ? "isOpen" : ""
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(NavBarMobile, {
                className: menuIsOpen ? "isOpen" : "",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("header", {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                                children: "MENU"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                type: "button",
                                onClick: ()=>setMenuIsOpen(false),
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* FiX */.q5L, {})
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(CategoriesMobile, {
                        onClickCategory: handleClickCategory,
                        categories: categories
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var components_Header = (Header);


/***/ })

}]);